import { Toolbar } from "@mui/material";
import FileUploadRoundedIcon from "@mui/icons-material/FileUploadRounded";
import logo from "../../assets/images/logo-white.svg";
import CustomIcon from "../CustomIcon/CustomIcon";
import { CustomButton } from "../CustomButton/CustomButton";
import * as Styles from "./CustomToolBar.styles";
import { useXmlImport } from "../../hooks/useXmlImport";

function CustomToolBar() {
  const { handleImportChangeWithSpinner } = useXmlImport();

  return (
    <Styles.Container>
      <Styles.StyledAppBar component="nav">
        <Toolbar>
          <Styles.LogoContainer>
            <Styles.Logo src={logo} alt="logo" />
            <h4>Zeus | Conferência de mercadorias</h4>
          </Styles.LogoContainer>

          <Styles.RightActionsContainer>
            <CustomButton
              onFileChange={handleImportChangeWithSpinner}
              endIcon={<CustomIcon Icon={FileUploadRoundedIcon} size={"var(--icon-size-md)"} color="currentColor" />}
              textColor="var(--color-text-inverse)"
              backgroundColor="var(--color-secondary)"
              hoverBackgroundColor="var(--color-secondary-hover)"
            >
              Carregar XML
            </CustomButton>
          </Styles.RightActionsContainer>
        </Toolbar>
      </Styles.StyledAppBar>

      <Styles.MainContent as="main">
        <Toolbar />
      </Styles.MainContent>
    </Styles.Container>
  );
}

export default CustomToolBar;
